import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

// Types
export interface CampaignCreationPayload {
  id?: string; // restaurant ID (optional, extracted from URL in saga)
  eventId?: string;
  event?: Record<string, any>;
  flyer?: Record<string, any>;
  title: string;
  type: string; // "MANUAL"
  offerDetails?: string;
  instructions?: string;
  description?: string;
  tagLine?: string;
  contactInfo?: string;
  validFrom: string; // Date format: "2026-03-20"
  validTo: string; // Date format: "2026-03-20"
  themeColour?: string;
  menuItems?: Array<Record<string, any>>;
  refImage?: string[];
  combo?: Array<Record<string, any>>;
}

export interface CampaignCreationState {
  loading: boolean;
  success: boolean;
  error: string | null;
  campaignId: string | null;
  response: any | null;
}

const initialState: CampaignCreationState = {
  loading: false,
  success: false,
  error: null,
  campaignId: null,
  response: null,
};

const campaignCreationSlice = createSlice({
  name: 'campaignCreation',
  initialState,
  reducers: {
    createCampaignRequest: (state, action: PayloadAction<CampaignCreationPayload>) => {
      state.loading = true;
      state.success = false;
      state.error = null;
      state.campaignId = null;
      state.response = null;
    },
    createCampaignSuccess: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.success = true;
      state.error = null;
      state.response = action.payload;
      // Try to extract campaign ID from response if available
      state.campaignId = action.payload?.campaignId || action.payload?.id || null;
    },
    createCampaignFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
      state.campaignId = null;
    },
    resetCampaignCreation: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.campaignId = null;
      state.response = null;
    },
  },
});

export const {
  createCampaignRequest,
  createCampaignSuccess,
  createCampaignFailure,
  resetCampaignCreation,
} = campaignCreationSlice.actions;

export default campaignCreationSlice.reducer;
